<script lang="ts">
  import type { Friend, Trip } from '../lib/types';

  type Item = Friend | Trip;

  export let items: Item[] = [];
  export let chipClass = '';
  export let emptyHtml = 'Nothing yet.';
  export let onRename: (id: string, name: string) => void;
  export let onRemove: (id: string) => void;
  export let onLoadSample: (() => void) | null = null;

  function rename(item: Item) {
    const next = prompt('Rename', item.name);
    if (next == null) return;
    const trimmed = next.trim();
    if (!trimmed || trimmed === item.name) return;
    onRename(item.id, trimmed);
  }
</script>

<div class="chip-list">
  {#if items.length === 0}
    <div class="chip-empty">
      {emptyHtml}
      {#if onLoadSample}
        <span class="link" role="button" tabindex="0" on:click={onLoadSample} on:keydown={(e) => e.key === 'Enter' && onLoadSample?.()}>load sample data</span>.
      {/if}
    </div>
  {:else}
    {#each items as item (item.id)}
      <span class="chip {chipClass}" title={item.formattedAddress || item.address || ''}>
        <span
          class="chip-name"
          role="button"
          tabindex="0"
          title="Click to rename"
          aria-label={`Rename ${item.name}`}
          on:click={() => rename(item)}
          on:keydown={(e) => e.key === 'Enter' && rename(item)}
        >{item.name}</span>
        <button class="chip-remove" aria-label={`Remove ${item.name}`} on:click={() => onRemove(item.id)}>×</button>
      </span>
    {/each}
  {/if}
</div>
